const caseStudies = [
  {
    id: "01",
    label: "RESUME-GROUNDED / CUSTOMER SOLUTION DESIGN",
    title: "From customer question to system story",
    summary: "A repeatable path from discovery to a technical direction people can believe in.",
    challenge: "Business needs rarely arrive as clean technical requirements. They arrive as pressure, uncertainty, and a room full of different priorities.",
    approach: "Lead discovery, shape the architecture, build the demo or proof of concept, then translate the trade-offs for both builders and decision-makers.",
    outcome: "A shorter distance between business need and technical decision — with a clearer handoff when the work moves forward.",
    tags: ["Cloud", "Data", "Integration", "Discovery"],
  },
  {
    id: "02",
    label: "RESUME-GROUNDED / PRODUCT ENGINEERING",
    title: "From legacy workflow to dependable product surface",
    summary: "Turning dense audit, reporting, and administration processes into software people can actually use.",
    challenge: "Operational software carries years of assumptions. A useful change has to respect the existing system while making the next step simpler.",
    approach: "Build and maintain web workflows, dashboards, data mapping, bug fixes, and deployment paths across PHP, ASP.NET, SQL, and cloud servers.",
    outcome: "A broader delivery range: not just imagining the system, but debugging, shipping, and supporting the thing after launch.",
    tags: ["Web", "Dashboards", "APIs", "Delivery"],
  },
  {
    id: "03",
    label: "SELF-INITIATED / AI SYSTEMS LAB",
    title: "Make emerging systems legible",
    summary: "A self-initiated concept for making agentic patterns concrete, inspectable, and useful to people outside the lab.",
    challenge: "New AI ideas can sound impressive while remaining hard to trust, explain, or connect to an actual decision.",
    approach: "Map retrieval, orchestration, guardrails, and human handoffs into a clear narrative — then use this portfolio itself as the first public proof of the approach.",
    outcome: "A living demonstration of how Armand thinks: make the complex visible, give it structure, and keep the human outcome in frame.",
    tags: ["Agents", "RAG", "Storytelling", "Self-initiated"],
  },
];

function CaseStudies() {
  return (
    <section id="selected-work" className="chapter casework-section" data-section="casework" data-testid="chapter-03-selected-work">
      <div className="chapter-intro">
        <div className="section-kicker"><span>03</span><span>SELECTED WORK / WITH CONTEXT</span></div>
        <div><h2 data-testid="selected-work-heading">The result is never just the build.</h2><p className="chapter-lead">A few ways I turn ambiguity into momentum — grounded in experience, with self-initiated work clearly marked as such.</p></div>
      </div>
      <div className="case-study-grid">
        {caseStudies.map((item, index) => (
          <article className="case-study-card reveal-item" key={item.id} data-testid={`selected-case-study-card-${index}`}>
            <div className="case-study-topline"><span>{item.label}</span><strong>0{item.id}</strong></div>
            <h3>{item.title}</h3>
            <p className="case-study-summary">{item.summary}</p>
            <div className="case-study-details"><div><span>THE TENSION</span><p>{item.challenge}</p></div><div><span>THE MOVE</span><p>{item.approach}</p></div></div>
            <div className="case-study-outcome"><span>OUTCOME</span><strong>{item.outcome}</strong></div>
            <div className="tag-row">{item.tags.map((tag) => <span key={tag}>{tag}</span>)}</div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CaseStudies;
